module.exports = __webpack_public_path__ + "static/img/sad.8e8bf5f5.svg";